import React, { useState } from "react";

export default function Menu() {
  const [menuOpen, setMenuOpen] = useState(false);
  const assetsUrl = process.env.REACT_APP_ASSETS_URL;
  console.log("Assets URL:", assetsUrl);

  // Smooth scroll to section
  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="relative w-screen h-screen overflow-hidden">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover"
      >
        <source src="/bg_1.mp4" />
        Your browser does not support the video tag.
      </video>
      {/* Mobile menu bar */}
      <div className="flex md:hidden w-full items-center justify-between px-4 py-4 absolute top-0 left-0 z-20">
        <img src="/xao_dao_text_logo.svg" alt="XAO.DAO Logo" className="w-32 h-32" />
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="w-12 h-12 flex flex-col items-center justify-center"
        >
          <span className="block w-8 h-1 bg-white rounded mb-2" />
          <span className="block w-8 h-1 bg-white rounded mb-2" />
          <span className="block w-8 h-1 bg-white rounded" />
        </button>
      </div>
      {/* Burger menu dropdown */}
      {menuOpen && (
        <div className="fixed top-0 left-0 w-full min-h-fit bg-black/80 z-30 flex flex-col items-center justify-center py-10">
          <button
            onClick={() => setMenuOpen(false)}
            className="absolute top-4 left-4 text-white text-3xl font-bold"
            aria-label="Close menu"
          >
            &times;
          </button>
          <div className="flex flex-col items-center space-y-6">
            {/* Legal Section */}
            <ul className="flex flex-col space-y-4 font-['Inter',_sans-serif] font-normal text-[20px] text-white text-center">
              <li>
                <div className="font-semibold">Legal</div>
              </li>
              <li><a href={process.env.REACT_APP_TERMS_AND_CONDITIONS_URL} target="_blank" rel="noopener noreferrer" className="">Terms & Conditions</a></li>
              <li><a href={process.env.REACT_APP_PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" className="">Privacy Policy</a></li>
            </ul>
            {/* Resources Section */}
            <ul className="flex flex-col space-y-4 font-['Inter',_sans-serif] font-normal text-[16px] text-white text-center mt-6">
              <li>
                <div className="font-semibold text-[20px]">Resources</div>
              </li>
              <li>
                <a href="#faq" onClick={(e) => handleNavClick(e, "faq")}>
                  FAQs
                </a>
              </li>
              <li>
                <a href="mailto:membership@xaodao.io">
                  Contact Us
                </a>
              </li>
            </ul>
            {/* XAO.DAO Section */}
            <ul className="flex flex-col space-y-4 font-['Inter',_sans-serif] font-normal text-[16px] text-white text-center mt-6">
              <li>
                <div className="font-semibold text-[20px]">XAO DAO</div>
              </li>
              <li>
                <a href="#about" onClick={(e) => handleNavClick(e, "about")}>
                  About
                </a>
              </li>
              <li>
                <a href="#join" onClick={(e) => handleNavClick(e, "join")}>
                  Join
                </a>
              </li>
              <li>
                <a
                  href="#proposals"
                  onClick={(e) => handleNavClick(e, "proposals")}
                >
                  Proposals
                </a>
              </li>
              <li>
                <a
                  href="#governance"
                  onClick={(e) => handleNavClick(e, "governance")}
                >
                  Governance Process
                </a>
              </li>
              <li>
                <a href="#grants" onClick={(e) => handleNavClick(e, "grants")}>
                  Grants
                </a>
              </li>
              <li>
                <a href="mailto:membership@xaodao.io">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      )}
      {/* Desktop nav and hero */}
      <nav className="hidden md:flex absolute top-0 left-0 w-full py-10 flex justify-center items-center z-10 bg-transparent">
        <ul className="flex space-x-8 font-['Inter',_sans-serif] font-normal text-[14px] text-white/75">
          <li>
            <a
              href="#about"
              onClick={(e) => handleNavClick(e, "about")}
              className="hover:text-white"
            >
              About
            </a>
          </li>
          <li>
            <a
              href="#join"
              onClick={(e) => handleNavClick(e, "join")}
              className="hover:text-white"
            >
              Join
            </a>
          </li>
          <li>
            <a
              href="#proposals"
              onClick={(e) => handleNavClick(e, "proposals")}
              className="hover:text-white"
            >
              Proposals
            </a>
          </li>
          <li>
            <a
              href="#governance"
              onClick={(e) => handleNavClick(e, "governance")}
              className="hover:text-white"
            >
              Governance Process
            </a>
          </li>
          <li>
            <a
              href="#grants"
              onClick={(e) => handleNavClick(e, "grants")}
              className="hover:text-white"
            >
              Grants
            </a>
          </li>
          <li>
            <a
              href="mailto:membership@xaodao.io"
              className="hover:text-white"
            >
              Contact
            </a>
          </li>
        </ul>
      </nav>
      <img
        src="/xao_dao_logo.png"
        alt="XAO.DAO Logo"
        className="h-1/4 relative mx-auto mt-40 mb-10 hidden md:block"
      />
      {/* Hero section below navbar */}
      <div className="relative z-10 flex flex-col items-center justify-center mt-40 md:mt-16 text-center px-4 md:mt-20">
        <h1 className="text-white text-2xl md:text-5xl font-medium mb-5 drop-shadow-lg no-wrap">
          The future of decision&#8209;making is now.
        </h1>
        <p className="text-white/75 text-sm md:text-base max-w-4xl mb-7 px-2">
          XAO DAO is a decentralized, on-chain governance protocol built for the XRP Ledger ecosystem.<br />
          Where proposals shape the <span className="italic font-semibold text-white">future</span>, and every member has a <span className="italic font-semibold text-white">voice</span>.
        </p>
        <div className="flex flex-col md:flex-row gap-4 items-center justify-center">
          <button className="bg-gradient-to-r from-[#1bdfff] via-[#0098fb] to-[#6777ff] text-white font-semibold text-sm md:text-base px-6 py-3 rounded-full flex items-center gap-2 shadow-xl hover:scale-105 transition-transform w-full md:w-auto">
             <a
              href={process.env.REACT_APP_XAODAO_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
            Join XAO DAO
            </a>
            <img src="./imageVector.png" alt="Arrow" className="w-5 h-5" />
          </button>
          <button className="bg-white/10 border border-white/30 text-white font-semibold text-sm md:text-base px-6 py-3 rounded-full flex items-center gap-2 shadow hover:scale-105 transition-transform w-full md:w-auto">
            <a
              href={`${assetsUrl}/help-video-1.mp4`}
              target="_blank"
              rel="noopener noreferrer"
            >
              How-To
            </a>
          </button>
          <button className="bg-white/10 border border-white/30 text-white font-semibold text-sm md:text-base px-6 py-3 rounded-full flex items-center gap-2 shadow hover:scale-105 transition-transform w-full md:w-auto">
            <a
              href={process.env.REACT_APP_XAODAO_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Connect Wallet
            </a>
          </button>
        </div>
      </div>
      {/* Strip section below hero - only desktop */}
      {/* <div className="hidden md:block bg-[rgba(255,255,255,0.03)] relative rounded-[62px] mx-auto mt-20 w-[90vw] max-w-[1216px]">
        <div className="box-border flex items-center justify-between overflow-clip px-[30px] py-3 w-full">
          <div className="flex gap-2 items-center">
            <span className="text-[12px] text-white/75 font-medium">Live Members:</span>
            <span className="text-[14px] text-white font-bold">34,102</span>
          </div>
          <div className="flex flex-row items-center self-stretch">
            <div className="bg-white/20 h-full rounded-[20px] w-px" />
          </div>
          <div className="flex gap-2 items-center">
            <span className="text-[12px] text-white/75 font-medium">XRPL Version:</span>
            <span className="text-[14px] text-white font-bold">v2.3.4</span>
          </div>
          <div className="flex flex-row items-center self-stretch">
            <div className="bg-white/20 h-full rounded-[20px] w-px" />
          </div>
          <div className="flex gap-2 items-center">
            <span className="text-[12px] text-white/75 font-medium">Validators Online:</span>
            <span className="text-[14px] text-white font-bold">57</span>
          </div>
          <div className="flex flex-row items-center self-stretch">
            <div className="bg-white/20 h-full rounded-[20px] w-px" />
          </div>
          <div className="flex gap-2 items-center">
            <span className="text-[12px] text-white/75 font-medium">Current Proposal: “Expand Ecosystem Grants” - Voting Ends in </span>
            <span className="text-[14px] text-white font-bold">03:12:48</span>
          </div>
          <div className="flex flex-row items-center self-stretch">
            <div className="bg-white/20 h-full rounded-[20px] w-px" />
          </div>
          <div className="flex gap-2 items-center">
            <span className="text-[12px] text-white/75 font-medium">XRP Price (FTSO Feed):</span>
            <span className="text-[14px] text-white font-bold">$0.62</span>
          </div>
        </div>
        <div
          aria-hidden="true"
          className="absolute border border-white/10 border-solid inset-0 pointer-events-none rounded-[62px] shadow-[0px_0px_44px_0px_rgba(0,0,0,0.25)]"
        />
      </div> */}
    </div>
  );
}